module.exports = __webpack_public_path__ + "2fd41ea8a527566b25d2ed460e9896a5.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/5.svg
// module id = 682
// module chunks = 0